<template>
  <v-container id="home_menu" fluid tag="section">
    <div>
      <Alert_personnel_report_rounds/>
        <Alert />
      <Alert_salary_gov v-if="period_college_80105.period_college_enable==='1' || period_college_80105.period_college_enable === 1" />
    
      
    </div>

    <v-card flat class="page-header-card mb-4">
      <v-card-text class="d-flex align-center flex-wrap pa-4">
        <div class="page-header-icon mr-3">
          <v-icon size="24" color="white">mdi-domain</v-icon>
        </div>
        <div class="mr-auto">
          <div class="page-header-title">เมนูหลักสถานศึกษา</div>
          <div class="page-header-subtitle grey--text text--darken-1">
            ผู้ใช้งานระบบ : {{ user.user_ID || "-" }} —
            {{ user.user_firstname }} {{ user.user_lastname || "" }}
          </div>
        </div>
        <v-chip
          color="success"
          text-color="white"
          v-if="user.user_status === 'active'"
        >
          กำลังใช้งาน
        </v-chip>
        <v-chip color="grey" text-color="white" v-else>
          {{ user.user_status || "-" }}
        </v-chip>
      </v-card-text>
    </v-card>

    <v-expansion-panels flat class="usage-guide-panel mb-4">
      <v-expansion-panel style="border: 1px solid #e2e8f0; border-radius: 10px;">
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="#1e293b">mdi-help-circle-outline</v-icon>
            <span class="font-weight-bold" style="color: #1e293b;">คำแนะนำการใช้งาน</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p class="mb-4">
            หน้านี้เป็น<strong>เมนูหลักของสถานศึกษา</strong> ใช้เข้าถึงระบบงานย่อยของวิทยาลัย
            ทั้งหมด ด้านบนสุดคือกำหนดการ/การแจ้งเตือนที่เกี่ยวข้องกับวิทยาลัยของท่าน (จะแสดง
            เฉพาะเมื่อมีรอบ/กำหนดการที่เปิดอยู่จริงเท่านั้น) ถัดลงมาคือเมนูนำทางไปยังระบบงานย่อยแต่ละกลุ่ม
          </p>
          <v-row dense>
            <v-col
              v-for="item in guideMenuItems"
              :key="item.anchor"
              cols="12"
              sm="6"
            >
              <div class="d-flex align-start guide-menu-item">
                <v-icon small class="mr-2 mt-1" color="#0f766e">{{ item.icon }}</v-icon>
                <div>
                  <span class="font-weight-medium">{{ item.title }}</span>
                  <div class="text-caption grey--text">{{ item.desc }}</div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="text-center pa-2 quick-nav-bar">
      <v-btn rounded outlined color="#1e293b" class="mr-1 mb-1" href="#t38MV"
        >ย้าย บุคลากรอื่น 38 ค.(2)</v-btn
      >
      <v-btn rounded outlined color="#1e293b" class="mr-1 mb-1" href="#condition"
        >เงือนไขสาขาวิชารับย้าย</v-btn
      >
      <v-btn rounded outlined color="#1e293b" class="mr-1 mb-1" href="#manpower"
        >ระบบอัตรากำลัง</v-btn
      >
      <v-btn rounded outlined color="#1e293b" class="mr-1 mb-1" href="#assisstant"
        >ครูผู้ช่วย</v-btn
      >
      <v-btn rounded outlined color="#1e293b" class="mr-1 mb-1" href="#gov_em"
        >พนักงานราชการ</v-btn
      >
    </div>
    <v-row no-gutters align="stretch">
      <v-col cols="12" md="6" class="pa-1 flex-card">
        <v-card class="section-card" id="userlogin">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-account-cog</v-icon>
            <span>ผู้ใช้งานระบบ</span>
          </div>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in user_system_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="pa-1 flex-card">
        <v-card class="section-card" id="college">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-domain</v-icon>
            <span>ข้อมูลวิทยาลัย</span>
          </div>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in college_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" class="pa-1">
        <v-card class="section-card" id="personnel">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-account-details</v-icon>
            <span>ข้อมูลงานบุคคล</span>
          </div>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in user_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

       <v-col cols="12" md="12" class="pa-1">
        <v-card class="section-card" id="manpower">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-human</v-icon>
            <span>ระบบอัตรากำลัง</span>
          </div>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in human_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>


        <v-col cols="12" md="12" class="pa-1">
        <v-card class="section-card" id="assisstant">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-human-male-male</v-icon>
            <span>ระบบครูผู้ช่วย</span>
            <v-spacer />
            <v-btn icon small @click="VideoDialogAssessmentDev()">
              <v-icon small color="white">mdi-video</v-icon>
            </v-btn>
          </div>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in prepare_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" class="pa-1">
        <v-card class="section-card" id="assisstant_dutyDirector">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-account-convert</v-icon>
            <span>คัดเลือก ตำแหน่ง รองผู้อำนวยการวิทยาลัย</span>
          </div>

          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in sedirector_app_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

       <v-col cols="12" md="12" class="pa-1">
        <v-card class="section-card" id="condition">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-source-branch</v-icon>
            <span>เงือนไขสาขาวิชา ตำแหน่ง ข้าราชการครู</span>
            <v-spacer />
            <v-btn icon small @click="VideoDialogConditionB()">
              <v-icon small color="white">mdi-video</v-icon>
            </v-btn>
          </div>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in condition_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

         <v-col cols="12" md="12" class="pa-1">
        <v-card class="section-card" id="t38MV">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-account-convert</v-icon>
            <span>รายงานการเสนอย้าย บุคลากรทางการศึกษาอื่นตามมาตรา 38 ค.(2)</span>
          </div>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in movement38_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" md="12" class="pa-1">
        <v-card class="section-card" id="gov_em">
          <div class="section-card-header">
            <v-icon size="18" color="white" class="mr-2">mdi-human-male-male</v-icon>
            <span>พนักงานราชการ</span>
          </div>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in govem_item"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <!-- V-model userdialog -->
    <v-layout row justify-center>
      <v-dialog v-model="adduserdialog" persistent max-width="80%">
        <v-card class="mx-auto pa-6" elevation="2">
          <base-material-card
            color="yellow"
            icon="mdi-clipboard-text"
            title="เปลี่ยนรหัสผ่าน"
            class="px-5 py-3 text_google"
            elevation="2"
          >
          </base-material-card>
          <v-card-text>
            <v-form ref="userform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    {{ user.user_name }} {{ user.user_firstname
                    }}{{ user.user_lastname }}
                  </v-flex>
                  <v-flex md12>
                    <v-text-field
                      outlined
                      label="รหัสผ่านปัจจุบัน"
                      v-model="old_password"
                      type="password"
                      required
                      :rules="[v => !!v || 'กรุณากรอกรหัสผ่านปัจจุบัน']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Password"
                      v-model="user.user_password"
                      type="password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Confirm Password"
                      v-model="user.user_confirmpassword"
                      type="password"
                      required
                      :rules="[v => v == user.user_password]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-container>
              <small>* จำเป็น</small>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large @click.stop="adduserdialog = false" rounded>
              <v-icon dark>mdi-close</v-icon>ยกเลิก
            </v-btn>
            <v-btn large color="warning" @click.stop="userSubmit()" rounded>
              <v-icon dark>mdi-pencil</v-icon>&nbsp;แก้ไข
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeManageMovement"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/Tg9DjFm6SDM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeManageMovement = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeConditionbranch"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/iVZy90tWSZg"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeConditionbranch = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeAssessmentDevTeach"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/IuTKn-M-KGY"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeAssessmentDevTeach = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </v-container>
</template>

<script>
import Alert from "../../components/college/alert.vue";
import Alert_personnel_report_rounds from "../../components/college/alert_personnel_report_rounds.vue";
import Alert_salary_gov from "../../components/gov_salary/alert_salary_gov.vue";
export default {
  components: { Alert, Alert_salary_gov, Alert_personnel_report_rounds },
  data() {
    return {
      ApiKey: "HRvec2021",
      user: [],
      periods: [],
      old_password: "",
      // รายการเมนูใช้แสดงในส่วน "คำแนะนำการใช้งาน" เท่านั้น อ้างอิงตาม id ของแต่ละ section ด้านล่าง
      guideMenuItems: [
        { anchor: "userlogin", title: "ผู้ใช้งานระบบ", icon: "mdi-account-cog", desc: "จัดการบัญชีผู้ใช้งานระบบของข้าราชการครูและบุคลากรทางการศึกษา" },
        { anchor: "college", title: "ข้อมูลวิทยาลัย", icon: "mdi-domain", desc: "ข้อมูลรายละเอียดของสถานศึกษา" },
        { anchor: "personnel", title: "ข้อมูลงานบุคคล", icon: "mdi-account-details", desc: "ข้อมูลข้าราชการครู/บุคลากร คุณวุฒิการศึกษา คัดเลือก/แข่งขันบุคลากร รายงานการเดินทางราชการ" },
        { anchor: "manpower", title: "ระบบอัตรากำลัง", icon: "mdi-human", desc: "กำหนดสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง ข้อมูลอัตรากำลังวิทยาลัย" },
        { anchor: "assisstant", title: "ระบบครูผู้ช่วย", icon: "mdi-human-male-male", desc: "รับรายงานตัว แต่งตั้งคณะกรรมการประเมิน รายงานผลการประเมินครูผู้ช่วย" },
        { anchor: "assisstant_dutyDirector", title: "คัดเลือกรองผู้อำนวยการ", icon: "mdi-account-convert", desc: "คัดเลือกและรับรายงานตัว ตำแหน่งรองผู้อำนวยการวิทยาลัย" },
        { anchor: "condition", title: "เงื่อนไขสาขาวิชา", icon: "mdi-source-branch", desc: "เงื่อนไขสาขาวิชา ตำแหน่งข้าราชการครู สำหรับรับย้าย" },
        { anchor: "t38MV", title: "ย้าย บุคลากรอื่น ม.38 ค.(2)", icon: "mdi-account-convert", desc: "รายงานการเสนอย้ายบุคลากรทางการศึกษาอื่นตามมาตรา 38 ค.(2)" },
        { anchor: "gov_em", title: "พนักงานราชการ", icon: "mdi-account-star", desc: "รับรายงานตัว ข้อมูลพนักงานราชการ ประเมินผลการปฏิบัติงาน คำนวณค่าตอบแทน" }
      ],
      adduserdialog: false,
      VideoDialogYoutubeManageMovement: false,
      VideoDialogYoutubeConditionbranch: false,
      VideoDialogYoutubeAssessmentDevTeach: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      user_system_items: [
        {
          text: "ข้อมูลผู้ใช้งานระบบ ข้าราชการครูและบุคลาการทางการศึกษา",
          icon: "mdi-account-arrow-right",
          to: "/college/personnel"
        }
      ],

      sedirector_app_items: [
        {
          text: "คัดเลือก ตำแหน่งรองผู้อำนวยการ",
          icon: "mdi-information",
          to: "/college/sedirector_app"
        },
        {
          text: "รับรายงานตัว ตำแหน่ง รองผู้อำนวยการ",
          icon: "mdi-account-star",
          to: "/college/sedirector_app_report"
        },
      ],

      college_items: [
        {
          text: "ข้อมูลรายละเอียดวิทยาลัย",
          icon: "mdi-information",
          to: "/college/collegeinfo"
        }
      ],

      user_items: [
        {
          text: "ข้อมูลข้าราชการครูและบุคลากรทางการศึกษา (จากส่วนกลาง)",
          icon: "mdi-account",
          to: "/college/personnel_tem"
        },
        {
          text:
            "ข้อมูลข้าราชการครูและบุคลากรทางการศึกษา (วิทยาลัย) งานอัตรากำลัง",
          icon: "mdi-account-settings",
          to: "/college/personnel_etc"
        },
        {
          text: "ข้อมูลคุณวุฒิการศึกษา",
          icon: "mdi-school",
          to: "/college/personnel_education"
        },
        {
          text: "คัดเลือก/แข่งขัน บุคลากร",
          icon: "mdi-account-search",
          to: "/college/temporarycollegeemreg"
        },

        {
          text: "รายงานการเดินทางราชการ",
          icon: "mdi-account-search",
          to: "/college/tripReport"
        }
      ],
      movement_items: [
        {
          text: "สายการสอนประสงค์ย้ายออก",
          icon: "mdi-account-circle",
          to: "/college/transference_personnel"
        },
        {
          text: "สายการสอนประสงค์ย้ายเข้า",
          icon: "mdi-account-circle",
          to: "/college/transference_personnel_movein"
        }
      ],

      movement38_items: [
        {
          text: "ประสงค์ย้ายออก",
          icon: "mdi-account-circle",
          to: "/college/transference_personnel_38"
        },
        {
          text: "ประสงค์ย้ายเข้า",
          icon: "mdi-account-circle",
          to: "/college/transference_personnel_movein_38"
        }
      ],

      movementmanagein_items: [
        {
          text: "สายบริหารในวิทยาลัยยืนย้าย",
          icon: "mdi-account-circle",
          to: "/college/transference_manage"
        }
      ],

      movementmanageout_items: [
        {
          text: "สายบริหารวิทยาลัยอื่นประสงค์ย้าย",
          icon: "mdi-account-circle",
          to: "/college/transference_manage_location"
        }
      ],

      condition_items: [
        {
          text: "ข้อมูลเงือนไขสาขาวิชาเอก",
          icon: "mdi-source-branch",
          to: "/college/conditions_branch"
        },
        {
          text: "ประวัติข้อมูลเงืนอไขสาขาวิชาเอก",
          icon: "mdi-source-branch",
          to: "/college/history_conditions"
        }
      ],

      human_items: [
        {
          text: "กำหนดสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง",
          icon: "mdi-account-multiple",
          to: "/college/man_power_j"
        },
        {
          text: "ข้อมูลทั่วไป",
          icon: "mdi-account-multiple",
          to: "/college/rate_workforce_g"
        },
        {
          text: "ข้อมูลอัตรากำลังวิทยาลัย",
          icon: "mdi-account-multiple",
          to: "/college/rate_workforce"
        },
        {
          text: "ข้อมูลอัตรากำลังวิทยาลัยสรุป",
          icon: "mdi-account-multiple",
          to: "/college/rate_workforce_pro"
        }
      ],

      prepare_items: [
        {
          text: "รับรายงานตัวครูผู้ช่วย",
          icon: "mdi-account-star",
          to: "/college/manage_assistant_teacher"
        },
        {
          text: "การแต่งตั้งคณะกรรมการประเมิน",
          icon: "mdi-account-star",
          to: "/college/assistantcommitteequalified"
        },
        {
          text: "รายงานผลการประเมิน",
          icon: "mdi-account-star",
          to: "/college/assistant_teacher"
        }
      ],
      sedirector_items: [
        
        {
          text: "รับรายงานตัว ตำแหน่ง ครูผู้ช่วย",
          icon: "mdi-account-star",
          to: "/college/manage_assistant_teacher"
        }
      ],
      govem_item: [
        {
          text: "รับรายงานตัว กรณี ย้าย",
          icon: "mdi-account-star",
          to: "/college/gov_em/receive_govem"
        },

         {
          text: "ข้อมูลพนักงานราชการ กรอบอัตรากำลัง",
          icon: "mdi-account-star",
          to: "/college/gov_em/government_employee"
        },


        {
          text: "ข้อมูลพนักงานราชการ และสัญญา",
          icon: "mdi-account-star",
          to: "/college/gov_em/personnel_govem"
        },

         {
          text: "รายงานผลการประเมินการปฏิบัติงาน",
          icon: "mdi-account-star",
          to: "/college/gov_em/assessment_govem"
        },


        {
          text: "การคำนวณค่าตอบแทนพนักงานราชการ",
          icon: "mdi-account-star",
          to: "/college/gov_em/cal_compensation"
        }
      ],
      period_college_80105:[],
    };
  },

  async mounted() {
    try {
      await this.getuser();
      await this.period_collegeQuery();
    } catch (error) {
      console.error("home_menu mounted error:", error);
    }
  },

  methods: {
    async period_collegeQuery(){
      let result = await this.$http.post('period_college.php',{
        ApiKey:this.ApiKey,
        period_college_id:"80105"
      })
      this.period_college_80105=result.data
    },
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    async getuser() {
      let result;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      result = await this.$http.post("admin.php", {
        user_name: userSession.user_name,
        ApiKey: "HRvec2021"
      });
      this.user = result.data;
    },

    async VideoDialogAssessmentDev() {
      this.VideoDialogYoutubeAssessmentDevTeach = true;
    },

    async VideoDialogConditionB() {
      this.VideoDialogYoutubeConditionbranch = true;
    },
    async VideoDialogManageMove() {
      this.VideoDialogYoutubeManageMovement = true;
    },

    async userUpdate() {
      this.adduserdialog = true;
    },

    async userSubmit() {
      if (this.$refs.userform.validate()) {
        try {
          this.user.ApiKey = this.ApiKey;
          this.user.old_password = this.old_password;
          let result = await this.$http.post("user.update_password.php", this.user);
          if (result.data && result.data.status) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.adduserdialog = false;
            this.old_password = "";
            this.user.user_password = "";
            this.user.user_confirmpassword = "";
          } else {
            Swal.fire({
              icon: "warning",
              title: (result.data && result.data.message) || "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        } catch (error) {
          console.error("userSubmit error:", error);
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.listcontent {
  background-color: #750606;
  border-bottom: 3px solid #d68822;
  height: 100px;
}

/* Page header - เข้าชุดสีกรมท่ามาตรฐานเดียวกับหน้าอื่นๆ ที่ปรับปรุงแล้ว */
.page-header-card {
  border-radius: 14px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
}

.page-header-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e293b, #334155);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.page-header-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.page-header-subtitle {
  font-size: 0.82rem;
  margin-top: 2px;
}

.guide-menu-item {
  padding: 4px 0;
}

.quick-nav-bar >>> .v-btn {
  font-weight: 500;
}

/* เมนูนำทาง (การ์ดแต่ละกลุ่ม) */
.section-card {
  border-radius: 14px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  height: 100%;
}

.section-card-header {
  display: flex;
  align-items: center;
  background: #1e293b;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  padding: 12px 20px;
}
</style>
